import React from "react";
import GroupHeader from "./GroupHeader";

const BoardGroup = React.memo(
  ({ groupName, index, isExpanded, onToggle, isMobile, children }) => (
    <div key={index} id={groupName}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "flex-start" : "space-between",
          marginBottom: "8px",
        }}
      >
        <GroupHeader
          groupName={groupName}
          isExpanded={isExpanded}
          onClick={onToggle}
          isMobile={isMobile}
        />
      </div>
      {isExpanded && children}
    </div>
  )
);

export default BoardGroup;
